import {
  StoreRequisitionStateTypes,
  StoreRequisitionActionTypes,
} from "./StoreRequisition.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: StoreRequisitionStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const StoreRequisitionReducer = (
  state: StoreRequisitionStateTypes = INITIAL_STATE,
  action: any
): StoreRequisitionStateTypes => {
  switch (action.type) {
    case StoreRequisitionActionTypes.FETCH_ALL_STORE_REQUISITION:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case StoreRequisitionActionTypes.FETCH_ALL_STORE_REQUISITION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case StoreRequisitionActionTypes.FETCH_ALL_STORE_REQUISITION_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case StoreRequisitionActionTypes.FETCH_ALL_STORE_REQUISITION_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case StoreRequisitionActionTypes.FETCH_ONE_STORE_REQUISITION:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case StoreRequisitionActionTypes.FETCH_ONE_STORE_REQUISITION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case StoreRequisitionActionTypes.FETCH_ONE_STORE_REQUISITION_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case StoreRequisitionActionTypes.FETCH_ONE_STORE_REQUISITION_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default StoreRequisitionReducer;
